/**
 * Created by noOne on 19/02/2018.
 */
"use strict";

import StackedSprite from "./StackedSprite";

export default class Player extends PIXI.Container {
    constructor() {
        super();

        //   this._stackHeight = 12;

        this._layers = [];

        // this.scale.set(2);
        const t = Common.assets.texture;
        // grab textures from sheet and pop them into a convenient array where they can be accessed using the tile id as the index
        let sheet = t("chr_sliced").baseTexture;
        sheet.scaleMode = PIXI.SCALE_MODES.NEAREST;

        let hei = 21;
        let wid = 20;

        let textures = [];
        let total = sheet.width / wid;
        //let tilesPerCol = sheet.height / Common.tileSize;
        // let totalTileTextures = 21;
        for (let i = 0; i < total - 1; i++) {
            textures.push(new PIXI.Texture(sheet, new PIXI.Rectangle(i * wid, 0, wid, hei)));
        }

        //textures = textures.reverse();

        this._textures = textures;

        this.init();

    }

    init() {
        for (let i = 0; i <= this._textures.length; i++) {
            //  let sp = P3.utils.sprite(t("iso_" + i), this, new PIXI.Point(0.5, 0.5));
            let sp = new PIXI.Sprite(this._textures[i]); //new PIXI.extras.TilingSprite(t("dirt_strip"), 32, 32);
            //sp.width = 16;
            sp.anchor.set(0.5);
            // sp.tilePosition.x = Math.round(Math.random() * 32);
            // sp.tilePosition.y = Math.round(Math.random() * 32);
            sp.y = -i * 4;
            sp.scale.set(4);

            // if (Math.random() < 0.5) sp.scale.x = -sp.scale.x;
            //  if (Math.random() < 0.5) sp.scale.y = -sp.scale.y;

            this._layers.push(sp);
            this.addChild(sp);
        }

        this._layers[0].width = 25;
        this._layers[0].height = 25;

        // this.scale.set(4);
    }

    setRotation(rotation) {
        for (let i = 0; i < this._layers.length; i++) {
            this._layers[i].rotation = rotation;
        }
    }

    test() {
        for (let i = 0; i < this._layers.length; i++) {
            this._layers[i].rotation += deltaTime * 0.25;
        }
    }

    get collisionRect() {
        return this._layers[0];
    }

}